<template>

    <Dialog :dialog="dlg">
        <template v-slot:title>Verkooporder maken</template>
        <template v-slot:content>

        <v-card flat>
        <v-card-text class="pb-2">
            <AlertArea primary>
                Van deze offerte wordt een order gemaakt.<br>
                Via de order kunt u deze offerte in delen uitfactureren.<br> 
                Na het aanmaken kunt u de order nog aanpassen.
            </AlertArea>
        </v-card-text>
        </v-card>
        <v-form ref="form" lazy-validation>
        </v-form>


            <v-form ref="form">
                
                <v-card flat><v-card-text  class="pt-2">
                    <v-row dense v-if="!dlg.isStatusAccepted">
                        <v-col>
                            <Checkbox label="Zet offertestatus naar 'Opdracht' na aanmaken order" v-model="dlg.set_next_state"></Checkbox>
                        </v-col>
                    </v-row>
                    <v-row dense v-else>
                        <v-col>
                            <Checkbox label="Zet offertestatus naar 'Gereed' na aanmaken order" v-model="dlg.set_next_state"></Checkbox>
                        </v-col>
                    </v-row>
                    <v-row dense >
                        <v-col>
                            <Checkbox label="Open direct de aangemaakte order" v-model="dlg.open_order"></Checkbox>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>
            <v-divider></v-divider>

            <v-card flat v-if="dlg.shouldSelectChapters">
                            <v-card-text>
                                <FormRow label="Hoofdstukken">
                                    <v-simple-table dense style="width:100%'">
                                    <tr v-for='(item, index) in dlg.chapters' :key='index'>
                                        
                                        <td style="width:40px;" class="xpy-2 pr-4">
                                            <Checkbox class=""  v-model="item.checked"></Checkbox>
                                        </td>
                                        <td class="cursor-pointer">
                                            <span class="xpy-2 pr-4" @click="()=>item.checked=!item.checked">{{ item.name||item.thp_name }}</span>
                                        </td>
                                        <td class="text-right">
                                            <AmountText :value='item.total||0'/>    
                                        </td>
                                    </tr>
                                    </v-simple-table>
                                    </FormRow>
                            </v-card-text>
            </v-card>

            <v-divider v-if="dlg.shouldSelectChapters"></v-divider>
            <v-card flat>
                <v-card-text>
                    <FormRow col-value-right label="Bedrag">
                        <AmountText :value='dlg.total||0'/>    
                    </FormRow>
                </v-card-text>
            </v-card>

            <v-divider></v-divider>


            <v-card flat>
                <v-card-text class="content">

                    <Radiogroup v-model="dlg.method" :rules="dlg.ruleMandatory">
                        <Radio class="mb-2" value="term" label="Maak termijnschema"/>
                        <Radio class="" value="lines" label="Importeer offerte regels"/>
                    </Radiogroup>
                </v-card-text>
            </v-card>
            <v-divider v-if="dlg.method=='term'" class="my-2"></v-divider>
            <v-card flat  v-if="dlg.method=='term'">
                <v-card-text class="content">
                    <FormRow label="Termijnschema">
                        <SalesOrderTermCombo :rules="(dlg.method=='term') ? dlg.ruleMandatory : []" v-model="dlg.id_order_term"></SalesOrderTermCombo>
                    </FormRow>
                </v-card-text>
            </v-card>


            </v-form>
        </template>


    </Dialog>

</template>

<script setup>

    import Dialog from '@shared/ui/dialogs/ModelDialog'
    import clsDialogModel from '@cls/clsDialogModel'
    import FormRow from '@controls/forms/FormRow'
    import { computed, ref } from 'vue'
    import AmountText from '@controls/text/Amount.vue'
    import Radiogroup from "@controls/check/Radiogroup.vue";
    import Radio from "@controls/check/Radio.vue";
    import SalesOrderTermCombo from '@controls/combo/SalesOrderTerm'
    import Checkbox from '@controls/check/Checkbox.vue'
    import string from '@lib/string'
    import AlertArea from '@shared/ui/markup/AlertArea'
    import Constants from '@app/consts'
    let form=ref(null)

    /**
     * For an alert dialog, we do not need a model. Just use the dialog.
     */
    class clsDialogCreateOrder extends clsDialogModel {
        method = "";
        chapters = [];
        id_order_term = null;
        set_next_state = false;
        open_order = true;
        id_status = null; 

        get fillable() { return ['method', 'chapters', 'id_order_term', 'id_tender', 'set_next_state', 'open_order', 'id_status']; }

        get isStatusAccepted() {
            return this.id_status == Constants.tender.status.STATUS_ACCEPTED;
        }
        get checkedChapters() {
            return (this.chapters||[]).filter( (ch) => !!ch.checked);
        }
        get shouldSelectChapters() {
            return this.chapters?.length > 1;
        }
        get total() {
            var total = 0;
            (this.chapters||[]).forEach( (ch) => {
                if (ch.checked) {
                    total += Number(ch.total||0);
                }
            })
            return total;
        }

        // load does just fill the model with default values. No server interaction.
        async load(params) {
            var data = {
                id_order_term: null,
                id_tender: params.tender.id,
                id_status: params.tender.id_status,                
                set_next_state: true,
                open_order: true,
                method: "",
                chapters: (params.tender.paragraphs||[]).map( (chapter, ix) => { 
                    return {
                        id: chapter.id,
                        ix: ix+1, 
                        checked: true, 
                        name: chapter.thp_name, 
                        total: chapter.total
                    }
                })
            };
            return data;
        }
        getCreateOptions() {
            return {
                method: this.method,
                id_order_term: this.id_order_term,
                id_tender: this.id_tender,
                set_next_state: this.set_next_state,
                open_order: this.open_order,
                chapters: this.checkedChapters.map( (ch) => ch.id),
            }
        }   
        // commit in our case just returns the data to the caller. No server interaction.
        // data already contains the toJSON()'d data members
        async save(data) {
            data.chapters = (this.chapters||[]).filter( (ch) => !!ch.checked).map( (ch) => ch.id);
            return data;
        }
    }

    let dlg = ref (new clsDialogCreateOrder( { 
        modelName: "tender_createorder",         
        title: "Verkooporder maken",
        forms: form, 
        icon: 'orders', 
        saveText: 'Ga door',
        noSubTitle: true, 
        useDirtyCheck: true,
        keepOpen: true,
    }));
    
</script>